<template>
	<transition name="fade">
		<div v-if="upsellModalOpen" class="modal" tabindex="-1" ref="upsellModal">
			<div class="modal-dialog">
				<div class="modal-content">
                    <div class="modal-body">
                        <div>
                            <h3>Upgrade available</h3>
                            <p v-html="upsellDetails.short_description"></p>
                        </div>
                        <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                            <div class="d-flex">
                                <img :src="imageBasePath + currentTyre.graphic" class="img-fluid" :alt="currentTyre.brand + ' logo'" @error="replaceOnError" style="max-width: 60px;" />
                                <div class="text-start ps-2">
                                    <b class="d-block mt-2">{{ currentTyre.brand }}</b>
                                    <p class="mb-0">{{ currentTyre.pattern }}</p>
                                    <p class="mb-0">{{ currentTyre.size }} {{ currentTyre.load_speed }}</p>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="badge bg-white text-primary primary-border my-2">Current Selection</span>
                                <div>
                                    <rating-labels :fuel="currentTyre.fuel" :wet="currentTyre.wet" :decibels="currentTyre.decibels" :noise-rating="currentTyre.noise_rating"></rating-labels>
                                </div>
                            </div>
                            <div>
                                <b class="d-block price">&pound;{{ currentTyre.retail}}</b>
                                <small class="d-block">per tyre</small>
                            </div>
                        </div>
                        <hr>
                        <div class="d-flex flex-column flex-sm-row align-items-center justify-content-between">
                            <div class="d-flex">
                                <img :src="imageBasePath + upsoldTyre.graphic" class="img-fluid" :alt="upsoldTyre.brand + ' logo'" @error="replaceOnError" style="max-width: 60px;" />
                                <div class="text-start ps-2">
                                    <b class="d-block mt-2">{{ upsoldTyre.brand }}</b>
                                    <p class="mb-0">{{ upsoldTyre.pattern }}</p>
                                    <p class="mb-0">{{ upsoldTyre.size }} {{ upsoldTyre.load_speed }}</p>
                                </div>
                            </div>
                            <div class="d-flex flex-column">
                                <span class="badge bg-success w-auto bg-dark-green my-2">Recommended Tyre</span>
                                <div>
                                    <rating-labels :fuel="upsoldTyre.fuel" :wet="upsoldTyre.wet" :decibels="upsoldTyre.decibels" :noise-rating="upsoldTyre.noise_rating"></rating-labels>
                                </div>
                            </div>
                            <div>
                                <p class="d-block price">&pound;{{ upsoldTyre.retail}}</p>
                                <small class="d-block">per tyre</small>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer shadow-lg d-flex align-items-center justify-content-center">
                        <button class="btn btn-custom-white flex-grow-2" @click="this.addToBasket(currentTyre.st_code, currentTyre.quantity, false)">Keep my choice</button>
                        <button class="btn btn-primary flex-grow-1" @click="this.addToBasket(upsoldTyre.st_code, upsoldTyre.quantity, true)">Upgrade and continue</button>
                    </div>
				</div>
			</div>
		</div>
	</transition>
</template>
<script>
    export default {
        props: ['currentTyre', 'upsoldTyre', 'upsellDetails', 'upsellModalOpen', 'imageBasePath'],
        data() {
            return {
            }
        },
        mounted() {
        },
        methods: {
            addToBasket(st_code, quantity, accepted) {
                this.$parent.addTyreToBasket(st_code, quantity);
                if(typeof(this.$gtag) !== 'undefined') {
                    this.$gtag.event('tyre_upsell', {
                        'event_category': 'Upsell ' + (accepted == true ? 'Accepted' : 'Rejected'),
                        'event_label': (accepted == true ? 'accepted' : 'rejected'),
                        'value': this.upsellDetails.id
                    });
                }
                else {
                    console.log('gtag not loaded');
                }
            },
            replaceOnError(e) {
                e.target.src = this.imageBasePath + 'brand_logos/generic.png'; 
            },
            replaceTyreOnError(e) {
                e.target.src = this.imageBasePath + 'coming_soon.png'; 
            },
        },
        computed: {
            currentTyreBrandImagePath() {
                return (this.imageBasePath + 'brand_logos/' + (this.currentTyre.brand_image != null ? this.currentTyre.brand_image : 'generic.png'));
            },
            upsoldTyreBrandImagePath() {
                return (this.imageBasePath + 'brand_logos/' + (this.upsoldTyre.brand_image != null ? this.upsoldTyre.brand_image : 'generic.png'));
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '@frontendAssets/sass/_variables.scss';

    .error {
        color: red;
    }
    .price {
        font-size: 18px;
        font-weight: 600;
    }
    .modal {
		background-color: rgba(0,0,0,.5);
	  	display: block;
        .modal-dialog {
            @media screen and (min-width: 768px) {
                width: 536px;
            }
        }
    }
    .d-contents {
        display: contents;
    }
</style>
